import React from "react";
import AppShell from "@/components/layout/AppShell";
import FeatureGate from "@/components/FeatureGate";
import StaffUploadCenter from "@/components/staff/StaffUploadCenter";

export default function StaffUploadCenterPage() {
  return (
    <AppShell pageTitle="Staff Upload Center">
      <FeatureGate feature="staff_compliance_tracker">
        <StaffUploadCenter />
      </FeatureGate>
    </AppShell>
  );
}
